module.exports = __webpack_public_path__ + "img/venus.1991603a.png";